import type { RouteRecordRaw } from 'vue-router'

function Layout() {
  return import('@/layouts/index.vue')
}

const routes: RouteRecordRaw = {
  path: '/announcement',
  component: Layout,
  name: 'AnnouncementManagement',
  meta: { title: '系统公告', icon: 'i-ep:bell', menu: false },
  children: [
    {
      path: 'list',
      name: 'AnnouncementList',
      component: () => import('@/views/system/announcement/index.vue'),
      meta: { title: '系统公告', icon: 'i-ep:bell' },
    },
    {
      path: 'create',
      name: 'AnnouncementCreate',
      component: () => import('@/views/system/announcement/form.vue'),
      meta: { title: '创建公告', icon: 'i-ep:plus', menu: false, activeMenu: '/announcement/list' },
    },
    {
      path: 'edit/:id',
      name: 'AnnouncementEdit',
      component: () => import('@/views/system/announcement/form.vue'),
      meta: { title: '编辑公告', icon: 'i-ep:edit', menu: false, activeMenu: '/announcement/list' },
    },
  ],
}

export default routes
